// extracted by mini-css-extract-plugin
export default {"interpretationScoreBar":"nTzyQvQy1lOvM1tlrcBG","segment":"P2bmfhfD5ctPOPOw5BeJ","scoreIndicator":"JzNBGVRZCHZgO1MolYzT","interpretationScoreBar__active":"YkjRgZt5jrtZmo7ybVaQ"};